<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @search-reset="searchClear" @refresh-change="refreshChange" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">
        <template slot-scope="scope" slot="skuValue">
          <div>{{ scope.row.skuValue }}</div>
        </template>
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-tickets" size="small" plain
            @click.stop="downloadExcelStockDetail">导出Excel</el-button>
          <el-button type="primary" icon="el-icon-printer" size="small" plain @click.stop="printJson()">打印</el-button>
        </template>
        <template slot="search">
          <el-form-item label="一级分类" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="firstClassifyName" placeholder="请选择一级分类" required @change="choseFirstClassifyName"
                value-key="id">
                <el-option v-for="item in firstClassifys" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="二级分类" size="small" style="margin-top: 4px">
            <el-select v-model="secondClassifyName" placeholder="请选择二级分类" required @change="choseSecondClassifyName"
              value-key="id">
              <el-option v-for="secondClassify in secondClassifys" :key="secondClassify.id" :label="secondClassify.name"
                :value="secondClassify.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌名称" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="searchBrand" placeholder="请选择品牌" value-key="id">
                <el-option v-for="brand in brands" :key="brand.id" :label="brand.name" :value="brand"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="success" icon="el-icon-view" size="small" plain
            @click.stop="toLog(scope.row.id)">查看</el-button>
          <!-- <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleCell(scope)"
          >入库</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.productStatus=='PUTAWAY' && false"
            @click.stop="singleProductDown(scope.row.id)"
          >下架</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.productStatus=='UNDERCARIAGE'&& false"
            @click.stop="singleProductPutAway(scope.row.id)"
          >上架</el-button> -->
        </template>
      </avue-crud>
      <!-- 弹窗 -->
      <el-dialog title="商品库存明细" :visible.sync="tableDataVisible" width="80%" :before-close="handleClose">
        <el-table :data="tableDataDetails" border style="text-align: left;">
          <el-table-column label="属性">
            <template slot-scope="scope">
              <div v-for="(attribute, index) in scope.row.attributes" :key="index">
                <span>{{ attribute.name }}: {{ attribute.value }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column prop="allAmount" label="总库存"></el-table-column>
          <el-table-column prop="amount" label="现有库存"></el-table-column>
          
        </el-table>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { stockMonitorDetailOption } from "@/const/salesCloud/stockMonitorDetailOption";
import { findCoupon } from "@/api/salesCloud/serviceCoupon";
import {
  InvoiceSystemV2StatisticsDetail,
  InvoiceSystemV2StatisticsDetailDownload,
  findStockMonitorDetailDownloadExcel
} from "@/api/salesCloud/credit";
import {
  findClassify,
  findBrand,
  chooseSecondClassify,
} from "@/api/salesCloud/stockGoods";
import { findByLabel, formatterTime } from "@/util/util";
import { DIC } from "@/const/dic";
import { getCompany } from "@/util/auth";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { excelaxios } from "@/util/excelaxios";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "detail",
  data() {
    return {
      tableOption: stockMonitorDetailOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      downloadData: {},
      firstClassifyName: "",
      secondClassifyName: "",
      firstClassifys: [],
      firstClassify: {},
      secondClassifys: [],
      secondClassify: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      dialogTableVisible: false,
      tableDataVisible: false,
      grade: {
        box: false,
        check: [],
      },
      productStatuses: DIC.PRODUCT_STATUS,
      brands: [],
      searchBrand: {},
      brand: {},
      departments: [],
      department: {},
      productStatus: "PUTAWAY",
      dispatching: "EXPRESS",
      describeImgs: [],
      wheelsImgs: [],
      fileList: [],
      fileList1: [],
      prices: [],
      clientTypes: DIC.CLIENT_TYPE,
      sku: {},
      skuList: [],
      tableData1: [],
      tableDataDetails: [],
      constitutes: [],
      dataSku1: [],
      coupon: {},
      coupons: [],
    };
  },
  created() {
    findClassify().then((res) => {
      let data = JSON.parse(res.data);
      this.firstClassifys = data;
    });
    findBrand().then((res) => {
      let data = JSON.parse(res.data);
      this.brands = data.rows;
    });
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    choseFirstClassifyName() {
      console.log("193choseFirstClassifyName", this);
      chooseSecondClassify(this.firstClassifyName.id).then((res) => {
        let data = JSON.parse(res.data);
        this.secondClassifys = data;
      });
      this.secondClassifyName = "";
    },
    choseSecondClassifyName() {
      console.log("199choseSecondClassifyName", this);
    },
    searchClear() {
      this.firstClassifyId = "";
      this.firstClassifyName = "";
      this.secondClassifys = "";
      this.secondClassifyName = "";
      this.searchBrand = {};
    },
    handleCell(scope) {
      this.dialogTableVisible = true;
      // console.log(row, index, this.dialogTableVisible);
      console.log(scope);
    },
    toLog(id) {
      // this.$router.push({ path: "warehousing/log" });
      // 打开el-table的弹窗展示
      this.tableDataVisible = true;
      this.tableLoading = true;
      let shopId = this.$route.params.id
      findStockMonitorDetailDownloadExcel(id,shopId).then((res) => {
        // console.log(res);
        let data = JSON.parse(res.data);
        this.tableDataDetails = this.formatTableData(data);
        this.tableLoading = false;
      });
    },
    formatTableData(goodsList) {
      let formattedData = [];
      if (goodsList.dataSku) {
        goodsList.dataSku.forEach((sku) => {
          let skuValues = sku.skuValue.split(':');
          let attributes = goodsList.skuConstitute.map((constitute, index) => ({
            name: constitute.constituteName,
            value: skuValues[index]
          }));

          let existingItem = formattedData.find((existingItem) => {
            return (
              existingItem.name === goodsList.name &&
              JSON.stringify(existingItem.attributes) === JSON.stringify(attributes)
            );
          });

          if (existingItem) {
            existingItem.amount += sku.amount;
          } else {
            formattedData.push({
              unit: goodsList.unit,
              attributes: attributes,
              allAmount: sku.allAmount,
              amount: sku.amount?sku.amount:0
            });
          }
        });
      } else {
        formattedData.push({
          unit: goodsList.unit,
          attributes: [{ name: 'N/A', value: 'N/A' }],
          amount: 'N/A'
        });
      }
      console.log(formattedData);
      return formattedData;
    },
    handleClose(done) {
      // this.$confirm("确认关闭？")
      //   .then((_) => {
          done();
        // })
        // .catch((_) => { });
    },
    handleAddRows() {
      // console.log(this.constitutes)
      let obj = "{";
      for (let i = 0; i < this.tableData1.length; i++) {
        if (i != this.tableData1.length - 1) {
          obj += "" + i + ":'',";
        } else {
          obj += "" + i + ":''";
        }
      }
      obj += "}";
      let dataObj = eval("(" + obj + ")");
      // console.log(dataObj)
      // let list = {
      //     price: '',
      //     goodsNumber:0,
      //     consumerDiscount:'',
      //     engineerDiscount:'',
      //     merchantDiscount:''
      // }
      this.constitutes.push(dataObj);
      console.log(this);
      // console.log(this.constitutes)
    },
    handleSteppingDelete(index, row) {
      // console.log(this.constitutes, 1111)
      this.constitutes.splice(index, 1);
      this.dataSku1.splice(index, 1);
      // console.log(this.dataSku1, 2222)
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      let id = this.$route.params.id;
      this.downloadData = params;
      InvoiceSystemV2StatisticsDetail(id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      let id = this.$route.params.id;
      this.downloadData = params;
      InvoiceSystemV2StatisticsDetail(id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.firstClassifyId = this.firstClassifyName.id
        ? this.firstClassifyName.id
        : "";
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      if (null != this.searchBrand.id && undefined != this.searchBrand.id) {
        params.brandId = this.searchBrand.id;
      } else {
        delete params.brandId;
      }
      params.secondClassifyId = this.secondClassifyName;
      console.log("282,searchChange", params);
      let id = this.$route.params.id;
      this.downloadData = params;
      InvoiceSystemV2StatisticsDetail(id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      let id = this.$route.params.id;
      this.downloadData = params;
      InvoiceSystemV2StatisticsDetail(id, params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // console.log(this.describeImgs)
    },
    handleEdit(row, index) { },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      console.log("handleList", params);
      let id = this.$route.params.id;
      this.downloadData = params;
      InvoiceSystemV2StatisticsDetail(id, params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(res);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) { },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      done();
    },
    handleDetail(row, index) { },
    async fnUploadWheelsImgs(option) {
      if (this.wheelsImgs.length >= 5) {
        this.$message({
          showClose: true,
          message: "轮播图不能超过五张",
          type: "error",
        });
        return;
      }
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs)
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.wheelsImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        // console.log(storeAs)
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
    downloadExcelStockDetail() {
      // let params = this.downloadData;
      // console.log(params);
      // let url = `/joins-invoice-system/v1/stock/exportStockDetail?`;
      // excelaxios(url, params);
      let params = this.downloadData;
      let id = this.$route.params.id;
      InvoiceSystemV2StatisticsDetailDownload(id, params).then((res) => {
        window.open(res);
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.firstClassifyId = this.firstClassifyName.id
        ? this.firstClassifyName.id
        : "";
      params.secondClassifyId = this.secondClassifyName;
      console.log("282,searchChange", params);
      let id = this.$route.params.id;
      InvoiceSystemV2StatisticsDetail(id, params).then((res) => {
        let data = JSON.parse(res.data);
        let someJSONdata = data.rows;
        console.log(someJSONdata);
        someJSONdata = someJSONdata.map((item) => {
          item.lastPurchaseTime = formatterDateToUTC(item.lastPurchaseTime);
          console.log(item);
          item.maps = item.skuValue;
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "name", displayName: "商品名称" },
            { field: "unit", displayName: "商品单位" },
            { field: "purchasePrice", displayName: "采购价格" },
            { field: "salePrice", displayName: "零售价格" },
            { field: "brandName", displayName: "品牌名称" },
            { field: "firstClassifyName", displayName: "一级分类" },
            { field: "secondClassifyName", displayName: "二级分类" },
            { field: "properties", displayName: "商品属性" },
            { field: "allPurchaseAmount", displayName: "总采购量" },
            { field: "nowAmount", displayName: "现有库存" },
            { field: "lastPurchaseTime", displayName: "上次采购时间" },
            { field: "outPerson", displayName: "出库人" },
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json",
        });
      });
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
